import React, { useEffect, useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import BankTransfer from "./BankTransfer";
import BankTransfer2to3 from "./BankTransfer2to3";
import BankTransfer4to5 from "./BankTransfer4to5";
import AtmWithdrawal from "./Atmwithdrawal";
import ApiButtonPage from "./ApiButtonPage";
import BankTransfer15to24 from "./BankTransfer15to24";
import BankTransfer15to25 from "./BankTransfer15to25";
import VerticalNav from "./VerticalNav";
import IndiaMap from "./India";
import Bank26to27 from "./Bank26to27";
import Dashboard from "./dashboard";
import LoginPage from "./LoginPage";
import PrivateRoute from "./PrivateRoute";
import NetworkFailureModal from "./networkFailureModal";
import BankTransfer4to5new from "./BankTransfer4to5new";
import BankTransfer15to24new from "./BankTransfer15to24new";
import BankTransfer15to25new from "./BankTransfer15to25new";
import BankTransfernew from "./BankTransfernew";
import AtmWithdrawalnew from "./AtmWithdrawalnew";
import BankTransfer2to3new from "./BankTransfer2to3new";
import Bank26to27new from "./Bank26to27new";
import Dashboardnew from "./dashboardnew";
import VerticalNavnew from "./VerticalNavnew";
import HomePage from "./HomePage";
import BankTransfer4to5new1 from "./BankTransfer4to5new1";

function LogoutHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout-event") {
        localStorage.removeItem("isLoggedIn");
        navigate("/");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  return null;
}

// 🔹 Move idle timeout logic inside a child component
function AppContent() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const idleTimeoutRef = useRef(null);
  const location = useLocation(); // Now it's inside a valid Router context
  const navigate = useNavigate(); // Get the navigate function

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetIdleTimeout();
  };

  const resetIdleTimeout = () => {
    if (location.pathname === "/") return; // Skip idle timeout on login page

    if (idleTimeoutRef.current) {
      clearTimeout(idleTimeoutRef.current);
    }
    idleTimeoutRef.current = setTimeout(() => {
      navigate("/");
      //}, 10 * 60 * 1000); // 10 minutes
    }, 30 * 60 * 1000); // 30 minutes


  };

  useEffect(() => {
    if (location.pathname === "/") return;

    const events = ["mousemove", "keydown", "click", "scroll"];

    const handleUserActivity = () => {
      resetIdleTimeout();
    };

    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity)
    );

    resetIdleTimeout();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity)
      );
      clearTimeout(idleTimeoutRef.current);
    };
  }, [location.pathname]);

  return (
    <>
      <LogoutHandler />
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/bank1to2"
            element={<PrivateRoute component={BankTransfer} />}
          />
          <Route
            path="/bank2to3"
            element={<PrivateRoute component={BankTransfer2to3} />}
          />
          <Route
            path="/bank4to5"
            element={<PrivateRoute component={BankTransfer4to5} />}
          />
          <Route
            path="/atm-withdrawal"
            element={<PrivateRoute component={AtmWithdrawal} />}
          />
          <Route
            path="/api-button"
            element={<PrivateRoute component={ApiButtonPage} />}
          />
          <Route
            path="/bank15to24"
            element={<PrivateRoute component={BankTransfer15to24} />}
          />
          <Route
            path="/bank15to25"
            element={<PrivateRoute component={BankTransfer15to25} />}
          />
          <Route
            path="/transactionmap"
            element={<PrivateRoute component={IndiaMap} />}
          />
          <Route
            path="/bank26to27"
            element={<PrivateRoute component={Bank26to27} />}
          />
          <Route
            path="/dashboard"
            element={<PrivateRoute component={Dashboard} />}
          />
          <Route
            path="/menu"
            element={<PrivateRoute component={VerticalNav} />}
          />
          <Route
            path="/bank4to5reference"
            element={<PrivateRoute component={BankTransfer4to5new} />}
          />
          <Route
            path="/bank4to5referencebanklogo"
            element={<PrivateRoute component={BankTransfer4to5new1} />}
          />
          {/* <Route
            path="/bank15to24reference"
            element={<PrivateRoute component={BankTransfer15to24new} />}
          />
          <Route
            path="/bank15to25reference"
            element={<PrivateRoute component={BankTransfer15to25new} />}
          />
          <Route
            path="/bank1to2reference"
            element={<PrivateRoute component={BankTransfernew} />}
          />
          <Route
            path="/atm-withdrawalreference"
            element={<PrivateRoute component={AtmWithdrawalnew} />}
          />
          <Route
            path="/bank2to3reference"
            element={<PrivateRoute component={BankTransfer2to3new} />}
          />
          <Route
            path="/bank26to27reference"
            element={<PrivateRoute component={Bank26to27new} />}
          />
          <Route
            path="/dashboardreference"
            element={<PrivateRoute component={Dashboardnew} />}
          />
          <Route
            path="/part2"
            element={<PrivateRoute component={VerticalNavnew} />}
          />
          <Route
            path="/home"
            element={<PrivateRoute component={HomePage} />}
          /> */}
        </Routes>
      </div>
      {isModalOpen && <NetworkFailureModal onClose={closeModal} />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
